/* istanbul ignore file */
// jsdom sets global === global.window so testing
// this wouldn't be easy at all
export default typeof window === 'undefined';
